import { render, staticRenderFns } from "./HighlightNumber.vue?vue&type=template&id=533919df&"
import script from "./HighlightNumber.vue?vue&type=script&lang=js&"
export * from "./HighlightNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533919df')) {
      api.createRecord('533919df', component.options)
    } else {
      api.reload('533919df', component.options)
    }
    module.hot.accept("./HighlightNumber.vue?vue&type=template&id=533919df&", function () {
      api.rerender('533919df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/components/HighlightNumber.vue"
export default component.exports